var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcUnchecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1519"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uD0C0\\uC6D0 76",
    style: {
      stroke: "#c6c6c6",
      strokeWidth: 3,
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 247",
    d: "m-7502.063-13654.654 5.185 5.215 8.51-8.256",
    transform: "translate(7509.922 13670.024)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#c6c6c6",
      strokeWidth: 3
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnchecked);
export default __webpack_public_path__ + "static/media/ic-unchecked.f15625cfe748f1c384f729bb0356859f.svg";
export { ForwardRef as ReactComponent };